
import FormField from './FormField.vue';
import Heading from './Heading.vue';
import Options from './Options.vue';
import Todos from './Todos.vue';

export default {
  components: { Heading, FormField, Options, Todos },
  name: 'Container',
};
